const ResetPassword = {
  'pages_login_ResetPassword.1': '비밀번호 재설정',
  'pages_login_ResetPassword.label.1': '상품 정보',
  'pages_login_ResetPassword.label.2': '새 비밀번호',
  'pages_login_ResetPassword.label.3': '새 비밀번호 재입력',
  'pages_login_ResetPassword.label.desc.1': '- 비밀번호 재 설정 시, 현재 비밀번호는 사용할 수 없습니다.',
  'pages_login_ResetPassword.label.desc.2': '- 아이디와 동일하게 비밀번호를 설정할 수 없습니다.',
  'pages_login_ResetPassword.label.desc.3': '- 비밀번호 변경 시, 현재 비밀번호와 동일한 비밀번호를 사용할 수 없습니다.',
  //'pages_login_ResetPassword.label.inquiry.1': '문의 사항이 있으시면 서비스 데스크로 문의 주세요.',
  'pages_login_ResetPassword.label.inquiry.2': '문의 하기',
  'pages_login_ResetPassword.label.inquiry.title': 'Customer Portal 로그인 관련 문의',

}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/lang/login/ResetPassword.kr.js